import { render, staticRenderFns } from "./TempStudentList.vue?vue&type=template&id=434ee7cd&scoped=true&"
import script from "./TempStudentList.vue?vue&type=script&lang=js&"
export * from "./TempStudentList.vue?vue&type=script&lang=js&"
import style0 from "./TempStudentList.vue?vue&type=style&index=0&id=434ee7cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434ee7cd",
  null
  
)

export default component.exports